module.exports = __webpack_public_path__ + "assets/img/flecha-izquierda-1.eb1bb5c6.svg";